export default {
  brandColor1: '#46bbbf',
  complimentaryColor1: '#fff',
  brandColor2: '#46bbbf',
  complimentaryColor2: '#fff',
};
